export class RoomRule {
  constructor(
    public readonly locationRegEx: string,
    public readonly roomId: string,
  ) {}
}
